import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

const ReferenceRuntimeChromeContext = createContext(false)

export function ReferenceRuntimeChromeProvider({ children }: { children: ReactNode }) {
  return <ReferenceRuntimeChromeContext.Provider value={true}>{children}</ReferenceRuntimeChromeContext.Provider>
}

/** True when rendering the reference tenant storefront (`LayoutRenderer`). */
export function useReferenceRuntimeChrome(): boolean {
  return useContext(ReferenceRuntimeChromeContext)
}
